import React from 'react';
import './index.scss';
import { Bubble } from 'tea-component'; 

export default function SaveFloatButton({
  success,
  handleClick,
  successText = '',
  failText = '',
}: {
  success: boolean;
  handleClick?: () => void;
  failText: any;
  successText: any;
}) {
  return (
    <Bubble placement="top-end" dark content={success ? successText : failText}>
      <div
        className={`dbo-button-float-save ${success ? '--success' : ''}`}
        onClick={handleClick}
      >
        <i className="dbo-button-float-save-icon"></i>
      </div>
    </Bubble>
  );
}
